import React from 'react';
import {useTheme} from '@mui/material';
import LocationManagedLocationChip from './LocationManagedLocationChip';

const AtCapacityChip = () => {
  const theme = useTheme();
  return <LocationManagedLocationChip label={'At Capacity'} chipColor={theme.palette.grey[700]} />
}

export default AtCapacityChip;
